import { render } from "./collection_progam_page.vue?vue&type=template&id=c8d89944&scoped=true"
import script from "./collection_progam_page.vue?vue&type=script&lang=js"
export * from "./collection_progam_page.vue?vue&type=script&lang=js"

import "./collection_progam_page.vue?vue&type=style&index=0&id=c8d89944&scoped=true&lang=css"

import exportComponent from "/Users/danramage/Documents/workspace/WaterQuality/RiverWQApp_Vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8d89944"]])

export default __exports__